
const Footer = props => {
  return <div className="footer">
    <div className="name">Download my resume <a href="/resume.pdf">Here.</a></div>
  </div>
}

export default Footer
